import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconVolumeHigh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.7001 12C19.7001 8.41362 17.2472 5.39736 13.9259 4.54252L14.4743 2.41196C18.744 3.5109 21.9001 7.38549 21.9001 12C21.9001 16.6145 18.744 20.4891 14.4743 21.588L13.9259 19.4575C17.2472 18.6026 19.7001 15.5864 19.7001 12ZM12.0001 3.2L6.5001 8.7H2.1001V15.3H6.5001L12.0001 20.8V3.2ZM13.6001 14.6472C14.4007 14.0706 14.9335 13.1053 14.9335 12C14.9335 10.8947 14.4007 9.92938 13.6001 9.35283L14.8001 7.68663C16.1274 8.64255 16.9869 10.2234 16.9869 12C16.9869 13.7766 16.1274 15.3574 14.8001 16.3134L13.6001 14.6472Z",
		fill: "black"
	})
});
export default SvgIconVolumeHigh;
